var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-address-block"},[_c('button',{on:{"click":_vm.addAddress}},[_vm._v("Добавить в список")])])}
var staticRenderFns = []

export { render, staticRenderFns }